<template>
  <div id="quill-editor-container">
    <quill-editor
      v-if="!refresh"
      v-model="quillContent"
      :options="options"
      @blur="e => $emit('blur', e)"
      @focus="e => $emit('focus', e)"
      @input="e => $emit('input', e)"
      @change="e => $emit('change', e)"
      @ready="e => $emit('ready', e)"
    >
    </quill-editor>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

export default {
  props: {
    content: {
      type: String,
      default: () => ''
    },
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    quillEditor
  },
  data () {
    return {
      refresh: false,
      quillContent: ''
    }
  },
  watch: {
    'content' () {
      this.setContent()
    },
    'options' () {
      this.refresh = true
      setTimeout(() => {
        this.refresh = false
        this.setContainerHeight()
      }, 0)
    }
  },
  created () {
    this.setContent()
    window.addEventListener('resize', this.setContainerHeight)
  },
  mounted () {
    this.setContainerHeight()
  },
  methods: {
    setContainerHeight () {
      let toolbar = document.getElementsByClassName('ql-toolbar ql-snow')[0]
      let container = document.getElementsByClassName('ql-container ql-snow')[0]
      if (toolbar && container) {
        container.style.height = 'calc(100% - ' + (toolbar.clientHeight + 1) + 'px)'
      } else {
        setTimeout(() => {
          this.setContainerHeight()
        }, 0)
      }
    },
    setContent () {
      this.quillContent = this.content
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  #quill-editor-container
    background: white
    width: 100%
    height: 100%
    .quill-editor
      height: 100%
</style>



// WEBPACK FOOTER //
// src/components/tool/quillEditor.vue